var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContainer)?_c('div',{key:_vm.key,class:['toast-notifications-container', _vm.$toasts.containerPosition]},_vm._l((_vm.toasts),function(toast){return _c('ToastNotification',{attrs:{"data":toast}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }